





















































import { Component, Vue } from "vue-property-decorator";
import Tooltip from "@/shared/components/tooltip.vue";
import DataTable from "@/shared/components/data-table.vue";
import { dateTimeSeconds } from "@/shared/filters";
import Manter from "./Manter.vue";
import {
  FilaMensagem,
  FilaMensagensService,
} from "@/services/fila-mensagens.service";

@Component({
  components: {
    Tooltip,
    DataTable,
    Manter,
  },
  filters: { dateTimeSeconds },
})
export default class FilaMensagens extends Vue {
  idConsultor: number | null = null;
  consultor: string | null = null;
  promise: Promise<FilaMensagem[]> | null = null;
  headers = [
    { value: "data", text: "Data", sortable: false },
    { value: "tipoMensagem", text: "Tipo da Mensagem" },
    { value: "mensagem", text: "Mensagem" },
    { value: "status", text: "Status Processamento" },
    { value: "actions", text: "Ações", sortable: false },
  ];

  status = {
    1: "Criado",
    2: "Processando",
    3: "Finalizado",
    4: "Erro",
  };

  mounted() {
    if (
      this.$route.params.idConsultor &&
      !isNaN(Number(this.$route.params.idConsultor))
    ) {
      this.idConsultor = Number(this.$route.params.idConsultor);
      this.fetchMensagens();
    }
  }

  async fetchMensagens() {
    if (this.idConsultor && !isNaN(Number(this.idConsultor))) {
      this.promise = FilaMensagensService.ListarFilaMensagemConsultor(
        this.idConsultor
      );
    }
  }

  async formatoJson(item: FilaMensagem) {
    this.$router.push({
      name: "manterfilamensagem",
      params: {
        idFilaMensagem: item.idFilaMensagem,
        idConsultor: this.idConsultor?.toString() ?? "",
      },
    });
  }

  tipoMensagem(tipo: number) {
    switch (tipo) {
      case 3:
        return "Erro Enviado";
      case 4:
        return "Erro ao Sincronizar";
      default:
        return tipo;
    }
  }
}
